<template>
  <v-container>
    <v-btn  color="primary" fab x-large dark to="/entry">
      <v-icon>mdi-map-marker-plus-outline</v-icon>
    </v-btn>
    
    <v-simple-table class="mt-5" :dense="false">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left type-column">Type</th>
            <th class="text-left address-column">Address</th>
            <th class="text-center edit-column">Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.id">
            <td>
              {{ entry.entry_type_name }}
            </td>
            <td>
              <div v-if="entry.street_address == placeholder_address">
                <v-icon class="mr-1">mdi-clock-outline</v-icon>
                Lookup pending
              </div>
              <div v-if="entry.street_address != placeholder_address">
                <v-icon class="mr-1" v-if="!entry.coords">mdi-clock-outline</v-icon>
                {{entry.street_address}}, {{entry.city}}
              </div>
            </td>
            <td class="text-center">
              <v-btn color="primary" class="mt-1 mb-1" v-bind:to="'/entry/'+ entry.id">
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn
            ></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<style scoped>
.address-column {
  width: 70%;
}
</style>

<script>
  import { db, firebase } from "@/firebaseInit.js";
  export default {
    data () {
      return {
        placeholder_address: "pending",
        entries: [],
      }
    },
    async created() {
      var user = await firebase.getCurrentUser();
      if (!user) return;
      const filtered_entries = db.collection('entry').where('user_id', '==', user.uid).orderBy('city').orderBy('street_address');
      this.$bind('entries', filtered_entries);
    },
  }
</script>